import { combineReducers } from "redux";
import Device from "./Device/Module";
import Clocking from "./Clocking/Module";
import ClockingCheck from "./ClockingCheck/Module";
import WorkingHours from "./WorkingHours/Module";
import Calendar from "./Calendar/Module";
import Policy from "./Policy/reducers";
import Writs from "./Writs/Module";
import Rules from "./Rules/Module";
import Reports from "./Reports/Module";
import Modifier from "./Modifier/Module";
import ModifierManagerOpinion from "./MonthlyManagerOpinion/Module";
import Stack from "./Stack/reducers";
import Shift from "./Shift/reducers";
import Setting from "./Setting/reducers.js";
import SettingAttendance from "./SettingAttendance/reducers";
import Salary from "./Salary/reducers";
import AIDataVisualizer from "./AIDataVisualizer/Module.js";
import Forgiveness from "./Forgiveness/reducers";
const reducers = combineReducers({
  Device,
  Clocking,
  WorkingHours,
  Calendar,
  Policy,
  Writs,
  Rules,
  Reports,
  Stack,
  Shift,
  Setting,
  ClockingCheck,
  Modifier,
  ModifierManagerOpinion,
  SettingAttendance,
  Salary,
  AIDataVisualizer,
  Forgiveness
});

export default reducers;
